import { combineReducers } from 'redux';

import {
    BonusSettlementCustomerOverviewReducerState,
    bonusSettlementsCustomerOverviewReducer,
} from './../detail/customer-overview/store/bonus-settlements-customer-overview-reducer';
import {
    BonusSettlementDetailSidebarReducerState,
    bonusSettlementsSupplierDetailSidebarReducer,
} from '../supplier-detail/store/sidebar-store/bonus-settlements-supplier-detail-sidebar-reducer';
import {
    BonusSettlementsCustomerDetailReducerState,
    bonusSettlementsCustomerDetailReducer,
} from '../customer-detail/store/bonus-settlements-customer-detail-reducer';
import {
    BonusSettlementsOverviewReducerState,
    bonusSettlementsOverviewReducer,
} from '../overview/store/bonus-settlements-overview-reducer';
import {
    BonusSettlementsSupplierDetailReducerState,
    bonusSettlementsSupplierDetailReducer,
} from '../supplier-detail/store/bonus-settlements-supplier-detail-reducer';
import {
    BonusSettlementsSupplierOverviewReducerState,
    bonusSettlementsSupplierOverviewReducer,
} from '../detail/supplier-overview/store/bonus-settlements-supplier-overview-reducer';

export interface BonusSettlementsReducerState {
    overview: BonusSettlementsOverviewReducerState;
    supplierOverview: BonusSettlementsSupplierOverviewReducerState;
    supplierDetail: BonusSettlementsSupplierDetailReducerState;
    settings: BonusSettlementDetailSidebarReducerState;
    customerOverview: BonusSettlementCustomerOverviewReducerState;
    customerDetail: BonusSettlementsCustomerDetailReducerState;
}

export const bonusSettlementsReducer = combineReducers<BonusSettlementsReducerState>({
    overview: bonusSettlementsOverviewReducer,
    supplierOverview: bonusSettlementsSupplierOverviewReducer,
    supplierDetail: bonusSettlementsSupplierDetailReducer,
    settings: bonusSettlementsSupplierDetailSidebarReducer,
    customerOverview: bonusSettlementsCustomerOverviewReducer,
    customerDetail: bonusSettlementsCustomerDetailReducer,
});
